import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {reduxForm, Field} from 'redux-form'
import {connect} from 'react-redux'
import {NavLink} from 'react-router-dom'
import DatePickerFormComponent from '../../../components/redux-form/DatePickerFormComponent'
import CategoriesSelectFormComponent from '../../../components/redux-form/CategoriesSelectFormComponent'
import VirtualizedSelectFormComponent from '../../../components/redux-form/VirtualizedSelectFormComponent'
import Captcha from '../../../components/Captcha'
import SplashLoginBtn from '../../../components/SplahsLoginBtn'
import './RegistrationUserInfo.css'
import LogoResidente from '../../../assets/logo-residente.png'
import LogoLavoratore from '../../../assets/logo-lavoratore.png'
import LogoStandard from '../../../assets/logo-standard.png'

const WHIRLPOOL_COMPANY_NAME = [
  'whirlpool s.p.a.',
  'whirlpool spa',
  'whirlpool EMEA s.p.a.',
  'whirlpool EMEA spa',
  'whirlpool',
  'wirlpool s.p.a.',
  'wirlpool spa',
  'wirlpool EMEA s.p.a.',
  'wirlpool EMEA spa',
  'wirlpool',
  'wirlpool s.p.a.',
  'wirlpool spa',
  'wirlpool EMEA s.p.a.',
  'wirlpool EMEA spa',
  'whirpool',
  'whirpool s.p.a.',
  'whirpool spa',
  'whirpool EMEA s.p.a.',
  'whirpool EMEA spa',
  'wirpool',
  'wirpool s.p.a.',
  'wirpool spa',
  'wirpool EMEA s.p.a.',
  'wirpool EMEA spa'
]

// const BLACKLIST_COMPANIES = [...WHIRLPOOL_COMPANY_NAME]
const BLACKLIST_COMPANIES = []

const RESIDENT_TYPES = {
  resident: 'resident',
  domiciled: 'domiciled'
}

class RegistrationUserInfo extends Component {
  static propTypes = {
    category: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      adressesOptions: props.addresses.data.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      }),
      companyName: null,
      isResidentOrDomiciled: RESIDENT_TYPES.resident
    }

    this.onCompanyNameChange = this.onCompanyNameChange.bind(this)
  }

  onCompanyNameChange (e) {
    this.setState({companyName: e.target.value})
  }

  isCompanyInBlackList () {
    if (!this.state.companyName) {
      return false
    }

    if (this.state.companyName.length < 7) {
      return false
    }

    for (let i = 0; i < BLACKLIST_COMPANIES.length; i++) {
      if (BLACKLIST_COMPANIES[i].toLowerCase().indexOf(this.state.companyName.toLowerCase()) > -1) {
        return true
      }
    }
    return false
  }

  render () {
    const {error, handleSubmit} = this.props
    return (<div>
      <div className="col-md-8 col-md-push-2">
        <div className="panel panel-default panel-border-login">
          {/* TELEFONO */}
          <div className={'row'}>
            <div style={{padding: 8}}>
              <div className="col-md-9 col-xs-9">
                <div className="registration-title-resident">REGISTRAZIONE</div>
                <div className="registration-resident-subtitle">
                  DA QUI PUOI RICHIEDERE UN NUOVO ACCOUNT PER LA PIATTAFORMA INSOSTA. <br />
                  INSERISCI TUTTE LE TUE INFORMAZIONI PERSONALI E QUELLE RIGUARDANTI <br />LA TUA CATEGORIA UTENTE.<br />
                </div>
              </div>
              <div className="col-xs-3 col-md-3">
                <a className="btn-social btn-outline">
                  <img className="registration-resident-logo" src={LogoResidente} />
                </a>
              </div>
            </div>
          </div>
          <div className="panel-body">
            <form onSubmit={handleSubmit}>
              <div className="box">
                {/* Inizio informazioni generali utente */}
                <fiedset>
                  <div className="registration-resident-title text-left">
                    INFORMAZIONI GENERALI
                  </div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Nome</label>
                      <Field component="input" name="firstName" type="text" className="resident-login" required />
                    </div>
                    <div className="col-md-6 text-left">
                      <label>Cognome</label>
                      <Field component="input" name="lastName" type="text" className="resident-login" required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>E-mail</label>
                      <Field component="input" name="email" type="text" className={'resident-login' + (this.props.formErrors.email ? ' form-error' : '')} required />
                      {this.props.formErrors.email && <span className="text-danger"> {this.props.formErrors.email}</span>}
                    </div>
                    <div className="col-md-6 text-left">
                      <label>Telefono Mobile</label>
                      <Field component="input" name="phone" type="text" placeholder="0123456789" className="resident-login" />

                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Password</label>
                      <Field component="input" name="password" type="password" className="resident-login" required />
                    </div>
                    <div className="col-md-6 text-left">
                      <label>Ripeti Password</label>
                      <Field component="input" name="repeatedPassword" type="password" className="resident-login" required />
                    </div>
                  </div>
                  <div className="row">
                    {this.props.formErrors.passwords && <span className="text-danger">{this.props.formErrors.passwords}</span>}
                  </div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Codice Fiscale</label>
                      <Field component="input" name="fiscalCode" type="text" className="resident-login" required />
                    </div>
                  </div>
                </fiedset>
                {/* Fine informazioni generali utente */}

                {/* Inizio Informazioni Residente */}
                {this.props.category.resident && <fiedset>
                  <div className="registration-resident-title text-left">
                    INFORMAZIONI RESIDENTE
                  </div>
                  <div>
                    <div className="row">
                      <div className="col-md-3 text-left">
                        <label>Data di Nascita</label>
                        <Field
                          placeholderText="GG/MM/AAAA"
                          component={DatePickerFormComponent}
                          name="birthDate"
                          className="resident-login"
                          required />
                      </div>
                      <div className="col-md-3 text-left">
                        <label>Sesso</label><br />
                        <label className="sex">
                          <Field name="sex" component="input" type="radio" value="M" required /> {' '} Uomo
                        </label>
                        {' '}
                        <label>
                          <Field name="sex" component="input" type="radio" value="F" required /> {' '} Donna
                        </label>
                      </div>
                      <div className="col-md-6 text-left">
                        <label>Città di Nascita</label>
                        <Field
                          name="birthPlace"
                          options={this.props.comuni}
                          component={VirtualizedSelectFormComponent}
                          required />
                      </div>
                    </div>
                    <div className="row" />
                    <div className="row">
                      <div className="col-md-12 text-left">
                        <label>Sei residente o domiciliato a Empoli?</label><br />
                        <label className="sex">
                          <input
                            type="radio"
                            value="resident"
                            name="isResidentOrDomiciled"
                            checked={this.state.isResidentOrDomiciled === RESIDENT_TYPES.resident}
                            onChange={() => this.setState({isResidentOrDomiciled: RESIDENT_TYPES.resident})}
                            required
                          />
                          {' '} Residente
                        </label>
                        <label style={{marginLeft: '20px'}}>
                          <input
                            type="radio"
                            value="domiciled"
                            name="isResidentOrDomiciled"
                            checked={this.state.isResidentOrDomiciled === RESIDENT_TYPES.domiciled}
                            onChange={() => this.setState({isResidentOrDomiciled: RESIDENT_TYPES.domiciled})}
                            required
                          />
                          {' '} Domiciliato
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-7 text-left">
                        <label>
                          Indirizzo di
                          {this.state.isResidentOrDomiciled === RESIDENT_TYPES.resident
                            ? ' Residenza'
                            : ' Domicilio'
                          }
                        </label>
                        <Field
                          onChange={(event, data) => this.props.onAddressSelected(data)}
                          name="residenceAddress"
                          options={this.props.addresses.data.map(item => {
                            return {
                              label: item.name,
                              value: item.id
                            }
                          })} component={VirtualizedSelectFormComponent} required />
                      </div>
                      <div className="col-md-2 text-left">
                        <label>N° Civico</label>
                        <Field
                          component="input"
                          name="residenceCivicNumber"
                          type="text"
                          placeholder="N°"
                          className="resident-login"
                          required />
                      </div>

                      {this.props.selectedArea && <div className="col-md-3 text-left">
                        <label>Area Selezionata</label>
                        <div style={{marginTop: 12}}>
                          <h4>{this.props.selectedArea.name}</h4>
                        </div>
                      </div>}
                    </div>

                    {this.state.isResidentOrDomiciled === RESIDENT_TYPES.domiciled && (
                      <div className="row">
                        <div className="col-md-7 text-left">
                          <label>Indirizzo di Residenza</label>
                          <Field
                            component="input"
                            name="secondaryResidenceAddress"
                            type="text"
                            placeholder="Indirizzo di residenza"
                            className="resident-login"
                            required
                          />
                        </div>
                        <div className="col-md-3 text-left">
                          <label>Città</label>
                          <Field
                            name="secondaryResidenceCity"
                            options={this.props.comuniWithoutLodi}
                            component={VirtualizedSelectFormComponent}
                            required />
                        </div>
                        <div className="col-md-2 text-left">
                          <label>CAP</label>
                          <Field
                            component="input"
                            name="secondaryResidenceCap"
                            type="text"
                            placeholder="CAP"
                            className="resident-login"
                            required
                          />
                        </div>
                      </div>
                    )}

                    {this.props.category.parkingInDifferentPlace && (
                      <div className="row">
                        <div className="col-md-7 text-left">
                          <label>
                            Indirizzo del posto auto
                          </label>
                          <Field
                            onChange={(event, data) => this.props.onParkingSpaceAddressSelected(data)}
                            name="parkingSpaceAddress"
                            options={this.props.addresses.data.filter(item => item.Area.code.indexOf("ZTL") !== -1).map(item => {
                              console.log(item)
                              return {
                                label: item.name,
                                value: item.id
                              }
                            })} component={VirtualizedSelectFormComponent} required />
                        </div>

                        {this.props.parkingSpaceSelectedArea && <div className="col-md-3 text-left">
                          <label>Area Del Posto Auto</label>
                          <div style={{marginTop: 12}}>
                            <h4>{this.props.parkingSpaceSelectedArea.name}</h4>
                          </div>
                        </div>}
                      </div>
                    )}
                  </div>
                </fiedset>}
                {/* Fine Informazioni Residente */}

                {/* Inizio Informazioni Lavoratore */}

                {this.props.category.worker && <fiedset>
                  <div className="titolo-categoria">
                    <legend className="text-left">{this.props.category.label}</legend>
                  </div>
                  <div>
                    <div className="row">
                      <div className="col-md-6 text-left">
                        <label>Nome Azienda</label>
                        <Field
                          onChange={this.onCompanyNameChange}
                          component="input" name="companyName" type="text"
                          placeholder="Nome Azienda..."
                          className={'resident-login' + (this.isCompanyInBlackList() ? ' has-error' : '')}
                          required />
                        {this.isCompanyInBlackList() && <span className="text-danger">
                          Errore! Questa azienda non fa parte del piano di sosta del Comune di Empoli
                        </span>}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-7 text-left">
                        <label>Indirizzo Sede</label>
                        <Field
                          component="input"
                          name="workAddress"
                          type="text"
                          placeholder="Indirizzo di residenza"
                          className="resident-login"
                        />
                      </div>
                      <div className="col-md-3 text-left">
                        <label>Città Sede</label>
                        <Field
                          name="workCity"
                          options={this.props.comuni}
                          component={VirtualizedSelectFormComponent}
                        />
                      </div>
                      <div className="col-md-2 text-left">
                        <label>CAP</label>
                        <Field
                          component="input"
                          name="workCap"
                          type="text"
                          placeholder="CAP"
                          className="resident-login"
                        />
                      </div>
                    </div>

                    {/*<div className="row">
                      <div className="col-md-7 text-left">
                        <label>Indirizzo di Lavoro</label>
                        <Field
                          onChange={(event, data) => this.props.onAddressSelected(data)}
                          name="workAddress" options={
                          this.props.addresses.data.map(item => {
                              return { label: item.name, value: item.id }
                            }
                          )} component={VirtualizedSelectFormComponent} required />
                      </div>
                      <div className="col-md-2 text-left">
                        <label>N° Civico</label>
                        <Field
                          component="input"
                          name="workCivicNumber"
                          type="text"
                          placeholder="N°"
                          className="resident-login"
                          required />
                      </div>

                      {this.props.selectedArea && <div className="col-md-3 text-left">
                        <label>Area Selezionata</label>
                        <div style={{marginTop: 12}}>
                          <h4>{this.props.selectedArea.name}</h4>
                        </div>
                      </div>}
                    </div>*/}

                    <div className="row">
                      <div className="col-md-6 text-left">
                        <label>Partita IVA</label>
                        <Field
                          component="input"
                          name="vatNumber"
                          type="text"
                          placeholder="0123456789"
                          className="resident-login"
                          required />
                      </div>
                    </div>
                  </div>
                </fiedset>}

                {this.props.category.workerPerson && <fiedset>
                  <div className="titolo-categoria">
                    <legend className="text-left">{this.props.category.label}</legend>
                  </div>
                  <div>
                    <div className="row">
                      <div className="col-md-6 text-left">
                        <label>Nome Azienda</label>
                        <Field
                            onChange={this.onCompanyNameChange}
                            component="input" name="companyName" type="text"
                            placeholder="Nome Azienda..."
                            className={'resident-login' + (this.isCompanyInBlackList() ? ' has-error' : '')}
                            required />
                        {this.isCompanyInBlackList() && <span className="text-danger">
                          Errore! Questa azienda non fa parte del piano di sosta del Comune di Empoli
                        </span>}
                      </div>
                    </div>

                    {/* <div className="row">
                      <div className="col-md-7 text-left">
                        <label>Indirizzo Sede</label>
                        <Field
                            component="input"
                            name="workAddress"
                            type="text"
                            placeholder="Indirizzo di residenza"
                            className="resident-login"
                        />
                      </div>
                      <div className="col-md-3 text-left">
                        <label>Città Sede</label>
                        <Field
                            name="workCity"
                            options={this.props.comuni}
                            component={VirtualizedSelectFormComponent}
                        />
                      </div>
                      <div className="col-md-2 text-left">
                        <label>CAP</label>
                        <Field
                            component="input"
                            name="workCap"
                            type="text"
                            placeholder="CAP"
                            className="resident-login"
                        />
                      </div>
                    </div> */}

                    <div className="row">
                      <div className="col-md-7 text-left">
                        <label>Indirizzo di Lavoro</label>
                        <Field
                          onChange={(event, data) => this.props.onAddressSelected(data)}
                          name="workAddress" options={
                          this.props.addresses.data.map(item => {
                              return { label: item.name, value: item.id }
                            }
                          )} component={VirtualizedSelectFormComponent} required />
                      </div>
                      <div className="col-md-2 text-left">
                        <label>N° Civico</label>
                        <Field
                          component="input"
                          name="workCivicNumber"
                          type="text"
                          placeholder="N°"
                          className="resident-login"
                          required />
                      </div>

                      {this.props.selectedArea && <div className="col-md-3 text-left">
                        <label>Area Selezionata</label>
                        <div style={{marginTop: 12}}>
                          <h4>{this.props.selectedArea.name}</h4>
                        </div>
                      </div>}
                    </div>

                    <div className="row">
                      <div className="col-md-6 text-left">
                        <label>Partita IVA</label>
                        <Field
                            component="input"
                            name="vatNumber"
                            type="text"
                            placeholder="0123456789"
                            className="resident-login"
                            required />
                      </div>
                    </div>
                  </div>
                </fiedset>}

                <div className="checkbox" style={{textAlign:'left'}}>
                  <label>
                    <Field component="input" type="checkbox" name={"privacy"} required />
                    Dichiaro di aver preso visione e di accettare l'informativa sulla privacy:{' '}
                    <NavLink to={'/privacy'}>Clicca qui per l'informativa completa</NavLink>
                  </label>
                </div>

                {this.props.loading && <div className="well">Registrazione in Corso...</div> }

                <div className="row">
                  <div className="col-md-4 col-md-offset-4" style={{marginTop: 10}}>
                    {/* <Field name='captcharesponse' component={Captcha}/> */}
                    {this.props.formErrors.form && <span className="text-danger">{this.props.formErrors.form}</span>}
                  </div>
                </div>
                <button disabled={this.isCompanyInBlackList()} type="submit" className="registration-btn">
                  REGISTRATI
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>)
  }
}

export default reduxForm({
  form: 'registrationUserInfo',
  enableReinitialize: true
})(RegistrationUserInfo)



// WEBPACK FOOTER //
// ./src/containers/Registration/UserInfo/RegistrationUserInfo.js